import React, { Fragment } from "react";

import img13 from "../../../images/service/digitalMarketing/digital-matekting-banner1.png";
import img14 from "../../../images/service/digitalMarketing/digital-matekting-banner2.png";
import img15 from "../../../images/service/digitalMarketing/digital-matekting-banner3.png";

// Service icons
import sIcon1 from "../../../images/icon/service-icon01.svg";
import sIcon2 from "../../../images/icon/service-icon02.svg";
import sIcon3 from "../../../images/icon/service-icon03.svg";
import sIcon4 from "../../../images/icon/service-icon04.svg";
import sIcon5 from "../../../images/icon/service-icon05.svg";
import sIcon6 from "../../../images/icon/service-icon06.svg";

// Common Components
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";

import HeroSection from "../../../components/PageSection/HeroSection";
import ServiceCardsSection from "../../../components/PageSection/ServiceCardSection";
import Benefit from "../../../components/PageSection/BenefitSection";
import KeyFeaturesSection from "../../../components/PageSection/KeyFeature";
import WhyChooseUsSection from "../../../components/PageSection/WhyChooseUsSection";
import FaqSection from "../../../components/PageSection/FAQsection";
import FinalCenteredCTA from "../../../components/PageSection/FinalCTA";
import Industries from "../../../components/Industries/Industries";
import TheorySection from "../../../components/PageSection/Theory";

// =====================
// DATA
// =====================

const serviceCards = [
  {
    icon: sIcon1,
    title: "Search Engine Optimization (SEO)",
    content:
      "Improve organic visibility and drive high-intent traffic through data-driven SEO strategies.",
  },
  {
    icon: sIcon2,
    title: "Social Media Marketing",
    content:
      "Build brand presence and engagement across social platforms with targeted campaigns.",
  },
  {
    icon: sIcon3,
    title: "Paid Advertising (PPC)",
    content:
      "Run high-conversion ad campaigns across Google, social media, and display networks.",
  },
];

const benefits = [
  {
    title: "Increased Brand Visibility",
    description:
      "Reach the right audience across search engines and digital platforms.",
    icon: sIcon1,
  },
  {
    title: "Higher Lead Generation",
    description:
      "Targeted campaigns convert visitors into qualified leads.",
    icon: sIcon2,
  },
  {
    title: "Cost-Effective Marketing",
    description:
      "Digital strategies deliver measurable ROI compared to traditional marketing.",
    icon: sIcon3,
  },
  {
    title: "Data-Driven Insights",
    description:
      "Track performance and optimize campaigns using real-time analytics.",
    icon: sIcon4,
  },
];

const faqs = [
  {
    q: "What is digital marketing?",
    a: "Digital marketing uses online channels such as search engines, social media, and email to promote products and services.",
  },
  {
    q: "How long does it take to see results?",
    a: "SEO takes time, while paid advertising and social media campaigns can show faster results.",
  },
  {
    q: "Do you offer customized marketing strategies?",
    a: "Yes. We create tailored marketing plans based on business goals and target audience.",
  },
  {
    q: "Can digital marketing help startups?",
    a: "Absolutely. Digital marketing is highly effective for startups due to its scalability and cost efficiency.",
  },
];

// =====================
// PAGE COMPONENT
// =====================

export default function DigitalMarketing() {
  return (
    <Fragment>
      <Header />

      <PageTitle
        pageTitle="Digital Marketing Services"
        pagesub="Growth-focused digital strategies that deliver results"
      />

      {/* HERO SECTION */}
      <HeroSection
        title={
          <>
            Grow Your Business with{" "}
            <span className="gradient-text">Digital Marketing</span>
          </>
        }
        subtitle={`Reach, engage, and convert your audience using
data-driven digital marketing strategies tailored to your business goals.`}
        buttonText="Book Consultation"
        buttonLink="/contact"
        image={img13}
        imageAlt="Digital Marketing Services"
      />

      {/* ================= THEORY 1 ================= */}
      <TheorySection
        title="What Is Digital Marketing?"
        image={img14}
        paragraphs={[
          "Digital marketing refers to promoting brands, products, and services using online channels such as search engines, social media, email, and websites.",
          "It enables businesses to reach targeted audiences, measure campaign performance, and optimize strategies in real time.",
        ]}
      />

      {/* SERVICES */}
      <ServiceCardsSection
        title="Our Digital Marketing Services"
        cards={serviceCards}
      />

      {/* ================= THEORY 2 ================= */}
      <TheorySection
        title="Why Digital Marketing Is Essential"
        image={img15}
        paragraphs={[
          "Consumers increasingly rely on digital platforms to discover and evaluate products and services.",
          "A strong digital marketing strategy helps businesses stay competitive, generate leads, and build long-term brand loyalty.",
        ]}
      />

      {/* BENEFITS */}
      <Benefit
        title="Benefits of Digital Marketing"
        benefits={benefits}
      />

      {/* KEY FEATURES */}
      <KeyFeaturesSection
        title="Key Features of Our Marketing Approach"
        subtitle="Performance-focused strategies built for growth"
        features={[
          {
            icon: sIcon1,
            title: "Audience Targeting",
            description:
              "Reach the right customers at the right time.",
          },
          {
            icon: sIcon2,
            title: "Multi-Channel Campaigns",
            description:
              "Integrated strategies across search, social, and email.",
          },
          {
            icon: sIcon3,
            title: "Conversion Optimization",
            description:
              "Improve landing pages and funnels for higher ROI.",
          },
          {
            icon: sIcon4,
            title: "Analytics & Reporting",
            description:
              "Transparent reporting and performance tracking.",
          },
          {
            icon: sIcon5,
            title: "Content Strategy",
            description:
              "Engaging content that attracts and retains users.",
          },
          {
            icon: sIcon6,
            title: "Continuous Optimization",
            description:
              "Ongoing testing and campaign improvements.",
          },
        ]}
      />

      <Industries />

      {/* WHY CHOOSE US */}
      <WhyChooseUsSection
        items={[
          "ROI-focused marketing strategies",
          "Experienced digital marketing professionals",
          "Transparent reporting and insights",
        ]}
      />

      {/* FAQ */}
      <FaqSection faqs={faqs} />

      {/* FINAL CTA */}
      <FinalCenteredCTA />

      <Footer />
      <Scrollbar />
    </Fragment>
  );
}
